/**
 * plugins/vuetify.ts
 *
 * Framework documentation: https://vuetifyjs.com`
 */

import "@mdi/font/css/materialdesignicons.css";
import "vuetify/styles";
import "@/styles/fonts.css";

import { createVuetify } from "vuetify";

export default createVuetify({
    theme: {
        defaultTheme: "light",
        themes: {
            light: {
                colors: {
                    primary: "#002595",
                    secondary: "#68ABD5",
                    white: "#FDFDFD",
                    black: "#000000",
                    darkGray: "#6D6D6D",
                    gray: "#C4C4C4",
                    lightGray: "#E4E4E8",
                    superLightGray: "#F0F0F2",
                    error: "#E6525E",
                    info: "#68ABD5",
                    success: "#76ED9E",
                    warning: "#F3E287",
                    "on-surface": "#6D6D6D",
                    "on-background": "#6D6D6D",
                    "on-superLightGray": "#6D6D6D",
                },
            },
            dark: {
                colors: {
                    primary: "#68ABD5",
                    secondary: "#68ABD5",
                    white: "#FDFDFD",
                    black: "#000000",
                    darkGray: "#B0B0B0",
                    gray: "#6D6D6D",
                    lightGray: "#3A3A3A",
                    superLightGray: "#2A2A2A",
                    error: "#E6525E",
                    info: "#68ABD5",
                    success: "#76ED9E",
                    warning: "#F3E287",
                    "on-surface": "#E4E4E8",
                    "on-background": "#E4E4E8",
                    "on-superLightGray": "#E4E4E8",
                },
                variables: {
                    "theme-overlay-multiplier": 6,
                    "theme-surface": "#1e1e1e",
                }
            },
            input: {
                dark: false,
                colors: {
                    surface: "#f2f2f5",
                },
            },
            dataTable: {
                dark: false,
                colors: {
                    "on-superLightGray": "#272727",
                },
            },
        },
    },
});
